<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="全部类型" class="fn-left">
            <Select key="5" :selected.sync="listQuery.shopId" :data="shopLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item class="fn-left">
            <el-button type="primary" @click="fnGetUnVisitStudentList()">查询 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="店铺名称" prop="shop_name" align="center" />
        <el-table-column label="学员姓名" align="center">
          <template slot-scope="{row}">
            <span :class="{text_danger:row.surplus_value>=120 }">{{ row.child_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前状态" prop="attendance_status_name" align="center" />
        <el-table-column label="班主任" prop="teacher_name" align="center" />
        <el-table-column label="剩余课时" prop="surplus_value" align="center" />
        <el-table-column label="上次回访时间" prop="visit_time" align="center" />

      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetUnVisitStudentList" />
    </div> -->

  </div>

</template>
<script>

import Select from '@/components/Select'

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'WarningStudentList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      shopLists: [],
      listQuery: {
        p: 1,
        limit: 20,
        shopId: ''
      }
    }
  },
  created() {
    this.fnGetSelectList()
    // this.fnGetUnVisitStudentList()
  },
  methods: {
    fnGetUnVisitStudentList: function() {
      this.bCreateReply = false
      this.$http.unVisitStudentList(this.listQuery).then(res => {
        this.lists = res.data
      })
    },
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.shopLists = res.data
      })
    }

  }
}
</script>
<style lang="scss">
  .text_danger{
    color:red
  }
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
